import { isAxiosError } from "axios";
import type { BiometricDeviceRecord, BiometricDeviceUpsertPayload } from "@/lib/admin/biometricDevicesStore";

export type BiometricDeviceFormState = {
  model: string;
  driver: string;
  wrapperClass: string;
  protocol: BiometricDeviceUpsertPayload["protocol"];
  description: string;
};

export const emptyBiometricDeviceForm = (): BiometricDeviceFormState => ({
  model: "",
  driver: "",
  wrapperClass: "",
  protocol: "tcp",
  description: "",
});

export function biometricDeviceToForm(record: BiometricDeviceRecord): BiometricDeviceFormState {
  return {
    model: record.model,
    driver: record.driver ?? "",
    wrapperClass: record.wrapperClass ?? "",
    protocol: record.protocol,
    description: record.description ?? "",
  };
}

export function biometricDeviceFormToPayload(form: BiometricDeviceFormState): BiometricDeviceUpsertPayload {
  return {
    model: form.model.trim(),
    driver: form.driver.trim() || null,
    wrapperClass: form.wrapperClass.trim() || null,
    protocol: form.protocol,
    description: form.description.trim() || null,
  };
}

export function biometricDeviceFormErrorMessage(error: unknown): string {
  if (isAxiosError(error)) {
    const data = error.response?.data as { message?: string; errors?: Record<string, string[]> } | undefined;
    if (data?.errors) {
      const first = Object.values(data.errors).flat()[0];
      if (first) return first;
    }
    if (typeof data?.message === "string") return data.message;
  }
  if (error instanceof Error && error.message) return error.message;
  return "Something went wrong. Please try again.";
}

export function formatBiometricDeviceProtocol(protocol: string): string {
  return protocol.toUpperCase();
}
